import { getPasswordKey } from './getPasswordKey.utils';

export async function cryptoUtils(text: string, encryptKey: string, mode: 'decrypt' | 'encrypt'): Promise<string> {
  const algorithmName: string = 'AES-GCM' as const;
  const saltLength: number = 16 as const;
  const ivLength: number = 12 as const;

  if (mode === 'decrypt') {
    try {
      const textDecoder: TextDecoder = new TextDecoder();
      const encryptedDataBuff: Uint8Array = Uint8Array.from(atob(text), (c: string): number => c.charCodeAt(0));
      const iv: Uint8Array = encryptedDataBuff.slice(saltLength, saltLength + ivLength);
      const data: Uint8Array = encryptedDataBuff.slice(saltLength + ivLength);
      const salt: Uint8Array = encryptedDataBuff.slice(0, saltLength);
      const passwordKey: CryptoKey = await getPasswordKey(encryptKey, salt, 'decrypt', algorithmName);

      const decryptedContent: ArrayBuffer = await window.crypto.subtle.decrypt(
        { name: algorithmName, iv },
        passwordKey,
        data
      );

      return textDecoder.decode(decryptedContent);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (_: unknown) {
      // todo: add logger
      return '';
    }
  } else {
    try {
      const textEncoder: TextEncoder = new TextEncoder();
      const iv: Uint8Array = window.crypto.getRandomValues(new Uint8Array(ivLength));
      const salt: Uint8Array = window.crypto.getRandomValues(new Uint8Array(saltLength));
      const passwordKey: CryptoKey = await getPasswordKey(encryptKey, salt, 'encrypt', algorithmName);

      const encryptedContent: ArrayBuffer = await window.crypto.subtle.encrypt(
        { name: algorithmName, iv },
        passwordKey,
        textEncoder.encode(text)
      );

      const encryptedContentArr: Uint8Array = new Uint8Array(encryptedContent);
      const buff: Uint8Array = new Uint8Array(
        salt.byteLength + iv.byteLength + encryptedContentArr.byteLength
      );
      buff.set(salt, 0);
      buff.set(iv, salt.byteLength);
      buff.set(encryptedContentArr, salt.byteLength + iv.byteLength);
      const base64Buff: string = btoa(
        new Uint8Array(buff).reduce((data: string, byte: number): string => data + String.fromCharCode(byte), '')
      );

      return base64Buff;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (_: unknown) {
      // todo: add logger
      return '';
    }
  }
}
